<div class="image-edit-container">
	<!-- AI Conversation Shell - Full Screen -->
	<app-ai-conversation-shell
		*ngIf="conversationConfig"
		[config]="conversationConfig"
		[messages]="conversationMessages"
		[useAdapter]="false"
		[isLoading]="isLoading"
		(sendMessage)="handleSendMessage($event.prompt)"
		(modelChanged)="handleModelChange($event)"
		(addReferenceImages)="openReferenceImagePicker()"
		(removeReferenceImage)="removeReferenceImage($event)"
	></app-ai-conversation-shell>
</div>
